import React from 'react'
import { Info } from 'lucide-react'
import { tokens } from '../../../assets/tokens'

const icon = props => <Info size={20} color={tokens.color.info.main} {...props} />

export default icon
